import { render, staticRenderFns } from "./PhoneNumber.vue?vue&type=template&id=35753a4c"
import script from "./PhoneNumber.vue?vue&type=script&lang=js"
export * from "./PhoneNumber.vue?vue&type=script&lang=js"
import style0 from "./PhoneNumber.vue?vue&type=style&index=0&id=35753a4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports